import React, { useEffect, useState } from "react";
import CustomButton from "../../components/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import base_url from "../../api/bootapi";
import { useNavigate } from "react-router-dom";
import { logout } from "../../components/Reducers/userSlice";
import SuccessPopUp from "../../components/SuccessPopUp";
import { useDisclosure } from "@mantine/hooks";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Modal } from "@mantine/core";

const NotificationPrefrence = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handle403error = (err) => {
    if (err) {
      if (err.response) {
        if (
          Number(err?.response?.status) === 403 ||
          Number(err?.response?.status) === 401
        ) {
          setTimeout(() => {
            console.log("Unauthorized or forbidden. Logging out.");
            dispatch(logout());
            // localStorage.clear();
            localStorage.setItem("from_403_status", "call_toast");
            navigate("/login");
            // toast.warn("Session Expired");
            // toast.success("Token Expired");
          }, 1000);
        }
      }
    }
  };

  const [opened, { open, close }] = useDisclosure(false);
  const [discardOpened, { open: discardOpen, close: discardClose }] =
    useDisclosure(false);
  const [emailSelected, setEmailSelected] = useState(false);
  const [phoneSelected, setPhoneSelected] = useState(false);
  const [smsSelected, setSmsSelected] = useState(false);
  const [notification, setNotification] = useState(false);
  const { user, token } = useSelector((state) => state.user);
  const [backdropopen, setbackdropopen] = useState(false);
  console.log(user);

  const toggleSelection = (type) => {
    if (type === "Email") setEmailSelected((prev) => !prev);
    if (type === "Phone") setPhoneSelected((prev) => !prev);
    if (type === "SMS") setSmsSelected((prev) => !prev);
  };

  const handleNotificationClick = () => {
    setNotification((prev) => !prev);
    setEmailSelected(false);
    setPhoneSelected(false);
    setSmsSelected(false);
  };

  useEffect(() => {
    const getUserData = async () => {
      setbackdropopen(true);
      try {
        const token = localStorage.getItem("client_token");

        if (!token) {
          // setPersonalDetailsError("Token not found!");
          navigate("/login");
        }

        const res = await axios.get(
          `${base_url.api1}/users/get_user?id=${user.id}`,
          {
            headers: {
              Authorization: `JWT ${token}`,
              Origin: "https://flyandclaim.odisoft.in",
            },
          }
        );
        const data = res.data.user;
        console.log("useEffect", data);
        if (
          !data.email_notification &&
          !data.phone_notification &&
          !data.sms_notification
        ) {
          setNotification(false);
        } else {
          setNotification(true);
          setEmailSelected(data.email_notification);
          setPhoneSelected(data.phone_notification);
          setSmsSelected(data.sms_notification);
        }
        setbackdropopen(false);
      } catch (error) {
        setbackdropopen(false);
        console.log(error);
        handle403error(error);
      }
    };
    getUserData();
  }, []);

  const handleSaveClick = async () => {
    setbackdropopen(true);
    try {
      const token = localStorage.getItem("client_token");

      if (!token) {
        // setPersonalDetailsError("Token not found!");
        navigate("/login");
      }

      const response = await axios.post(
        `${base_url.api1}/users/update_user`,
        {
          id: user.id,
          email_notification: emailSelected,
          sms_notification: smsSelected,
          phone_notification: phoneSelected,
          email: user.email,
        },
        {
          headers: {
            Authorization: `JWT ${token}`,
            Origin: "https://flyandclaim.odisoft.in",
          },
        }
      );

      console.log("user updated successfully", response.data);
      setbackdropopen(false);
      open();
    } catch (err) {
      setbackdropopen(false);
      console.log(err);
      handle403error(err);
    }
  };

  const handleCancelClick = () => {
    setNotification(false);
    setEmailSelected(false);
    setPhoneSelected(false);
    setSmsSelected(false);
    discardClose();
  };

  // console.log("Email", emailSelected);
  // console.log("Phone", phoneSelected);
  // console.log("SMS", smsSelected);

  return (
    <div className="manage-wrapper">
      <h3>Notification preferences</h3>

      <Modal
        opened={discardOpened}
        onClose={discardClose}
        centered
        radius={"lg"}
        size={"md"}
        withCloseButton={false}
      >
        <div
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "30px",
            padding: "30px",
          }}
        >
          {/* <CircleTickIcon /> */}
          <h5
            style={{ color: "#314064", fontSize: "24px", textAlign: "center" }}
          >
            Are you sure want to discard changes ?
          </h5>

          <div className="logout-btn-wrapper">
            <CustomButton
              style={{ width: "50%" }}
              btnText={"No"}
              flex={1}
              onClick={discardClose}
              type="secondary"
            />

            <CustomButton
              style={{ width: "50%" }}
              btnText={"Yes"}
              flex={1}
              onClick={handleCancelClick}
            />
          </div>
        </div>
      </Modal>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropopen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div>
        <div className="manage-personal-info notifications-container">
          <h5>Notifications</h5>
          <div className="notification-email-container">
            <p>Notification updates</p>
            <label className="switch">
              <input
                type="checkbox"
                checked={notification}
                onChange={() => handleNotificationClick()}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>

        <hr />
        {/* change pass container  */}
        <div className="manage-change-pass-container ">
          <h5>Set preferred contact method</h5>

          <div className="notification-ratio-container">
            <div className="radio-input-wrapper notification-ratio-button">
              <input
                type="radio"
                id="Email"
                value="Email"
                name="Email"
                checked={emailSelected}
                onChange={() => toggleSelection("Email")}
                disabled={!notification}
              />
              <label htmlFor="Email">Email</label>
            </div>
            <div className="radio-input-wrapper notification-ratio-button">
              <input
                type="radio"
                id="Phone"
                value="Phone"
                name="Phone"
                checked={phoneSelected}
                onChange={() => toggleSelection("Phone")}
                disabled={true}
              />
              <label htmlFor="Phone">Phone</label>
            </div>
            <div className="radio-input-wrapper notification-ratio-button">
              <input
                type="radio"
                id="SMS"
                value="SMS"
                name="SMS"
                checked={smsSelected}
                onChange={() => toggleSelection("SMS")}
                disabled={true}
              />
              <label htmlFor="SMS">SMS</label>
            </div>
          </div>
        </div>
      </div>
      <div className="manage-buttons-container">
        <CustomButton
          type="secondary"
          btnText={"CANCEL"}
          onClick={discardOpen}
        />
        <CustomButton btnText={"SAVE"} onClick={() => handleSaveClick()} />
      </div>

      <SuccessPopUp
        opened={opened}
        close={close}
        messageText="Notification Updated Successfully!"
        messagePara="Your notification prefrences have been Updated Successfully."
      />
    </div>
  );
};

export default NotificationPrefrence;
{
  /* <div className="radio-input-wrapper notification-ratio-button">
<input type="radio" id="Phone" value="Phone" name="Phone" disabled  style={{ cursor: "not-allowed" }} />
<label htmlFor="Phone" style={{ cursor: "not-allowed" }}>Phone</label>
</div> */
}
